// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2lbSV","buttons":"Footer_buttons__2nMCM"};